<template>
  <el-dialog
    ref="lr_Dialog"
    :visible.sync="midVisible"
    :custom-class="myClass"
    :modal="modal"
    :append-to-body="true"
    :close-on-click-modal="closeOnClickModal"
    :title="title"
    :before-close="beforeClose"
    :destroy-on-close="destroyOnClose"
    :width="isfullscreen ? '100%' : `${numberWidth}px`"
    :style="{
      'padding-left': `${left + move.left}px`,
      'padding-top': `${top + move.top}px`,
      'pointer-events': modal ? '' : 'none',
    }"
    :class="{ 'learun-dialog-top': !modal , 'auto-height-box': autoHeight && !isfullscreen}"
    :show-close="false"
    @open="openDialog"
    @opened="openedDialog"
    @close="closeDialog('')"
    @closed="closedDialog"
  >
    <template #title>
      <div
        class="l-dialog-header"
        :style="{ cursor: !autoHeight && !isMin ? 'move' : '' }"
        @mousedown="onMousedown"
      >
        <slot name="title">
          <div class="el-dialog__title" :title="title">
            <span class="el-dialog__title__text" >{{ title }}</span>
          </div>
        </slot>
        <div class="l-dialog-header-icons">
          <button
            v-if="showMinBtn"
            @click="handleMin"
            type="button"
            class="el-dialog__headerbtn"
          >
            <i
              :class="[
                'el-dialog__close',
                { 'learun-icon-unfold': isMin },
                { 'learun-icon-narrow': !isMin },
              ]"
            ></i>
          </button>
          <button
            @click="handleIsFull"
            type="button"
            class="el-dialog__headerbtn"
            style="margin-right: 10px;"
            v-if="showFullBtn"
          >
            <i style="font-size: 13px;" v-if="isfullscreen" class="el-dialog__close el-icon learun-icon-narrow"></i>
            <i style="font-size: 13px;" v-else class="el-dialog__close el-icon learun-icon-unfold"></i>
          </button>
          <button
            v-if="showClose"
            @click.stop="closeDialog('close')"
            @mousedown.stop
            style="margin-left: 10px"
            type="button"
            class="el-dialog__headerbtn"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
      </div>
    </template>
    <div
      v-show="!isMin"
      v-loading="loading"
      :element-loading-text="$t(loadingText)"
      :class="[
        'l-dialog-window',
        { 'l-dialog-window-hasBtns': hasBtns },
        { 'l-dialog-window-hasSteps': isStep },
      ]"
      :style="{ height: autoHeight ? 'auto' : heightComputed + 'px' }"
    >
      <el-steps
        v-if="isStep"
        :active="stepActive"
        simple
        finish-status="success"
      >
        <el-step
          v-for="(item, index) in steps"
          :key="index"
          :title="$t(item)"
        ></el-step>
      </el-steps>

      <slot></slot>

      <div class="l-dialog-btns" v-if="hasBtns">
        <slot name="btns">
          <slot name="stepExtendBtns"></slot>
          <el-button
            v-if="isStep"
            @click="prev"
            :plain="theme == 'dark'"
            size="mini"
            :disabled="stepPrevBtn"
            >{{ $t("上一步") }}</el-button
          >
          <el-button
            v-if="isStep"
            @click="next"
            :plain="theme == 'dark'"
            size="mini"
            :disabled="stepNextBtn"
            :loading="nextBtnLoading"
            >{{ $t("下一步") }}</el-button
          >
          <el-button
            v-if="!isStep && showClose"
            :plain="theme == 'dark'"
            size="mini"
            @click="closeDialog('cancel')"
            >{{ $t(cancelBtnLabel) }}</el-button
          >
          <el-button
            :plain="theme == 'dark'"
            size="mini"
            type="primary"
            @click="handleOk"
            :loading="btnLoading"
            :disabled="stepSaveBtn && isStep"
            >{{ isStep ? $t(okBtnLabel || "完成") : $t(okBtnLabel) }}</el-button
          >
        </slot>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "l-dialog",
  props: {
    title: String,
    showFullBtn: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    },
    width: {
      type: [String, Number],
      default: 600,
    },
    height: {
      type: Number,
      default: 400,
    },

    modal: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },

    beforeClose: Function,
    destroyOnClose: {
      type: Boolean,
      default: false,
    },

    hasBtns: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showMinBtn: {
      type: Boolean,
      default: false,
    },

    autoHeight: {
      type: Boolean,
      default: false,
    },

    isStep: {
      type: Boolean,
      default: false,
    },
    stepActive: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    validateSteps: Function,

    theme: {
      type: String,
      default: "default", // dark
    },

    placement: {
      type: String,
      default: "center", // 'top' 'top-left' 'top-right' 'left' 'center' 'right' 'bottom-left' 'bottom' 'bottom-right'
    },
    zoomControls: {
        type: Boolean,
        default: true
    },
    defaultFull: { // 是否默认全屏
      type: Boolean,
      default: false
    },
    okBtnLabel:{
      type: String,
      default: '确定'
    },
    cancelBtnLabel:{
      type: String,
      default: '取消'
    }
  },
  watch: {
    visible: {
      handler(n) {
        this.midVisible = n;
      },
    },
    isfullscreen: {
        handler: function(val) {
          if (val) {
            this.moveTop = this.move.top,
            this.moveLeft = this.move.left,
            this.move.top = 0,
            this.move.left = 0,
            this.latestHeight && (this._height = this.latestHeight,
            this.latestHeight = document.body.clientHeight - this.elDialogHeaderH),
            this.isMin = !1
          } else {
            this.move.top = this.moveTop,
            this.move.left = this.moveLeft,
            this.latestHeight = this._height
          }
        }
    },
    isMin: {
      handler: function(val) {
        if (val) this.isfullscreen = false
      }
    }
  },
  data() {
    return {
      loading: false,
      loadingText: "",
      midVisible: false,
      nextBtnLoading: false,
      btnLoading:false,

      stepPrevBtn: true,
      stepNextBtn: false,
      stepSaveBtn: true,

      move: {
        isMove: false,
        pageX: 0,
        pageY: 0,

        left: 0,
        top: 0,

        _left: 0,
        _top: 0,
      },
      isMin: false,
      isfullscreen: false,
      elDialogDom: '',
      elDialogHeaderH: ''
    };
  },
  mounted() {
    if (this.defaultFull) {
      this.isfullscreen = true
    }
  },
  computed: {
    heightComputed() {
      if (this.isfullscreen) return document.body.clientHeight - this.elDialogHeaderH;
      let _height = this.height;
      if (_height + 40 > document.body.clientHeight) {
        _height = document.body.clientHeight - 32 - 40;
      }
      return _height;
    },
    left() {
      let _left = 0;
      if (["top", "center", "bottom"].includes(this.placement)) {
        _left = (document.body.clientWidth - this.numberWidth) / 2;
      } else if (["top-left", "left", "bottom-left"].includes(this.placement)) {
        _left = 16;
      } else if (
        ["top-right", "right", "bottom-right"].includes(this.placement)
      ) {
        _left = document.body.clientWidth - this.numberWidth - 16;
      }

      //_left += this.move.left

      return this.isfullscreen || _left;
    },
    top() {
      let _top = 0;
      if (["top", "top-left", "top-right"].includes(this.placement)) {
        _top = 16;
      } else if (["left", "center", "right"].includes(this.placement)) {
        _top = (document.body.clientHeight - this.heightComputed - 40) / 2;
      } else if (
        ["bottom-left", "bottom", "bottom-right"].includes(this.placement)
      ) {
        _top = document.body.clientHeight - this.heightComputed - 40 - 16;
      }

      //_top += this.move.top

      return this.isfullscreen || _top;
    },
    numberWidth() {
      let _width = 0;
      if (typeof this.width == "string") {
        if (this.width.indexOf("px") > -1) {
          _width = Number(this.width.replace("px", ""));
        } else {
          _width =
            (Number(this.width.replace("%", "")) * document.body.clientWidth) /
            100;
        }
      } else {
        _width = this.width;
      }

      if (_width > document.body.clientWidth) {
        _width = document.body.clientWidth - 32;
      }

      return _width;
    },
    /*myWidth(){
      if(typeof this.width == 'string'){
        return this.width
      }
      else{
        return `${this.width}px`
      }
    },*/
    myStepActive: {
      get() {
        return this.stepActive;
      },
      set(val) {
        this.$emit("update:stepActive", val);
      },
    },
    myClass() {
      let _class = "";

      if (this.theme == "dark") {
        _class = "l-dialog-dark";
      } else {
        _class = "l-dialog";
      }
      if (this.isMin) {
        _class += ` l-dialog-min l-dialog-bottom-right`;
      } else {
        if (this.autoHeight) {
          _class += ` l-dialog-${this.placement}`;
        }
      }
      if (this.isfullscreen) {
          _class += ` is-fullscreen`;
        }
      return _class;
    },
  },
  methods: {
    handleClose(type) {
      // this.midVisible = false;
      this.$emit("close", 'cancel');
    },
    handleOk() {
      this.$emit("ok", this.showLoading, this.hideLoading);
    },
    handleMin() {
      this.isMin = !this.isMin;
    },
    handleIsFull() {
      this.isfullscreen = !this.isfullscreen
      this.$emit("full", this.isfullscreen);
    },

    closeDialog(type) {
      // this.isfullscreen = false
      if (type == 'close' && this.beforeClose) {
        return this.beforeClose(() => {
          this.$emit("update:visible", false);
          this.$emit("close", type);
        })
      }
      this.$emit("update:visible", false);
      this.$emit("close", type);
    },
    closedDialog() {
      this.move.left = 0;
      this.move.top = 0;
      this.isMin = false;
      if (this.isStep) {
        this.myStepActive = 0;
        this.$nextTick(() => {
          this.updateBtnState();
        });
      }
      this.$emit("closed");
    },
    openDialog() {
      this.$emit("open");
    },
    openedDialog() {
      this.$emit("opened", this.showLoading, this.hideLoading);
      if (this.zoomControls) {
        this.elDialogDom = this.$refs.lr_Dialog.$el.querySelector(".el-dialog")
        
        // this.elDialogDom.onmousemove = this.elDialogOnMousemove
      }
      this.$nextTick(() => {
        this.elDialogHeaderH = this.$refs.lr_Dialog.$el.querySelector(".el-dialog__header").offsetHeight + 1
      })
    },
    showLoading(text) {
      this.loadingText = text || "保存数据中...";
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },

    // 带步骤的表单
    prev() {
      if (this.myStepActive > 0) {
        this.myStepActive--;
      }
      this.$nextTick(() => {
        this.updateBtnState();
      });
    },
    async next() {
      if (await this.myValidateSteps()) {
        if (this.myStepActive < this.steps.length - 1) {
          this.myStepActive++;
        }
        this.$nextTick(() => {
          this.updateBtnState();
        });
      }
    },
    updateBtnState() {
      this.stepSaveBtn = true;
      this.stepNextBtn = true;
      this.stepPrevBtn = true;
      switch (this.myStepActive) {
        case 0:
          this.stepNextBtn = false;
          break;
        case this.steps.length - 1:
          this.stepPrevBtn = false;
          this.stepSaveBtn = false;
          break;
        default:
          this.stepPrevBtn = false;
          this.stepNextBtn = false;
          break;
      }
    },
    async myValidateSteps() {
      this.nextBtnLoading = true;
      if (this.validateSteps) {
        const res = await this.validateSteps(this.stepActive);
        this.nextBtnLoading = false;
        return res;
      }
      this.nextBtnLoading = false;
      return true;
    },

    onMousedown: function (e) {
      if (this.autoHeight || this.isMin) {
        return;
      }
      this.move.pageX = e.pageX;
      this.move.pageY = e.pageY;

      this.move._left = this.move.left;
      this.move._top = this.move.top;
      this.move.isMove = true;

      document.onmouseup = this.onMouseup;
      document.onmousemove = this.onMousemove;
    },

    onMousemove: function (e) {
      if (this.move.isMove) {
        const x = e.pageX - this.move.pageX;
        const y = e.pageY - this.move.pageY;

        let _left = this.move._left + x;
        let _top = this.move._top + y;

        if (_left + this.left < 0) {
          _left = -this.left;
        }

        if (_left + this.numberWidth + this.left > document.body.clientWidth) {
          _left = document.body.clientWidth - this.numberWidth - this.left;
        }

        if (_top + this.top < 0) {
          _top = -this.top;
        }
        if (
          _top + this.heightComputed + this.top + 40 >
          document.body.clientHeight
        ) {
          _top =
            document.body.clientHeight - this.heightComputed - this.top - 40;
        }
        this.move.left = _left;
        this.move.top = _top;
        this.isfullscreen && (this.isfullscreen = false)
      }
    },
    onMouseup: function () {
      this.move.isMove = false;
      document.onmousemove = document.onmouseup = null;
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
.auto-height-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0 !important;
  padding-top: 0 !important;
  // ::v-deep {
    .el-dialog {
      max-height: 100%;
      max-width: 100%;
    }
  // }
  .l-dialog-window {
    max-height: calc(100vh - 40px);
    &.l-dialog-window-hasBtns > div {
      max-height: calc(100vh - 40px - 48px);
    }
    & > div {
      max-height: calc(100vh - 40px);
      overflow: auto;
    }
    .l-dialog-btns {
      z-index: 9;
      background: #FFF;
    }
  }
}
</style>
